import './global.scss'

/* Contains PostHog's main styling configurations */
